/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Permission_See_All_Chats_Hint_OnInputs */



/**
* | output |
* | --- |
* | "Can read every member's chats, attached files and AI-created documents in this project, without writing in them." |
*
* @param {Projects_Permission_See_All_Chats_Hint_OnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const projects_permission_see_all_chats_hint_on = /** @type {((inputs?: Projects_Permission_See_All_Chats_Hint_OnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Permission_See_All_Chats_Hint_OnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Darf die Chats, angehängten Dateien und KI-erstellten Dokumente aller Mitglieder in diesem Projekt lesen, ohne darin zu schreiben.")
	return /** @type {LocalizedString} */ ("Can read every member's chats, attached files and AI-created documents in this project, without writing in them.")
});